import { createAction } from 'spw-redux/types';
import { Category } from 'spw-redux/modules/space_types/types';
import { IPhoto } from 'spw-redux/modules/photo/types';
import { REQUEST_STATUS } from 'spw-constants';
import { IUsage } from '../floorplan/types';
import { IBuilding, IFloor } from '../projects/types';
import {
  IRound,
  ISpaceRound,
  OccupancyAndUtilizationSummaries,
  RoundVM,
} from './types';

export const FETCH_PROJECT_ROUNDS = 'ou/FETCH_PROJECT_ROUNDS';
export const FETCH_PROJECT_ROUNDS_SUCCEEDED =
  'ou/FETCH_PROJECT_ROUNDS_SUCCEEDED';

export const FETCH_SPACE_ROUNDS = 'ou/FETCH_SPACE_ROUNDS';
export const FETCH_SPACE_ROUNDS_SUCCEEDED = 'ou/FETCH_SPACE_ROUNDS_SUCCEEDED';

export const GET_OCCUPANCY_AND_UTILIZATION_SUMMARIES =
  'ou/GET_OCCUPANCY_AND_UTILIZATION_SUMMARIES';
export const GET_OCCUPANCY_AND_UTILIZATION_SUMMARIES_SUCCEEDED =
  'ou/GET_OCCUPANCY_AND_UTILIZATION_SUMMARIES_SUCCEEDED';

export const CLEAN_UP_OCCUPANCY_AND_UTILIZATION_SUMMARIES =
  'ou/CLEAN_UP_OCCUPANCY_AND_UTILIZATION_SUMMARIES';

export const CLEAN_UP_OU = 'ou/CLEAN_UP_OU';

export const SET_CURRENT_ROUND = 'ou/SET_CURRENT_ROUND';
export const SET_CURRENT_ROUND_BUILDING = 'ou/SET_CURRENT_ROUND_BUILDING';
export const SET_CURRENT_ROUND_FLOOR = 'ou/SET_CURRENT_ROUND_FLOOR';
export const SET_CURRENT_ROUND_SPACE_CATEGORY =
  'ou/SET_CURRENT_ROUND_SPACE_CATEGORY';

export const POPULATE_ROUND_USAGES = 'ou/POPULATE_ROUND_USAGES';
export const POPULATE_ROUND_PHOTOS = 'ou/POPULATE_ROUND_PHOTOS';
export const FETCH_ROUND_PHOTOS = 'ou/FETCH_ROUND_PHOTOS';
export const SET_ROUNDS_REQUEST_STATUS = 'ou/SET_ROUNDS_REQUEST_STATUS';
export const SET_REPORT_ZIP_FILE_NAME = 'ou/SET_REPORT_ZIP_FILE_NAME';

const fetchProjectsRounds = (projectId: number) =>
  createAction(FETCH_PROJECT_ROUNDS, { projectId });

const fetchProjectsRoundsSucceeded = (
  rounds: RoundVM[],
  selectedRoundsMap?: { [roundId: number]: boolean }
) =>
  createAction(FETCH_PROJECT_ROUNDS_SUCCEEDED, {
    rounds,
    selectedRoundsMap,
  });

const fetchSpaceRounds = (spaceId: number) =>
  createAction(FETCH_SPACE_ROUNDS, { spaceId });

const fetchSpaceRoundsSucceeded = (rounds: ISpaceRound[]) =>
  createAction(FETCH_SPACE_ROUNDS_SUCCEEDED, { rounds });

const getOccupancyAndUtilizationSummaries = (
  roundIds: number[],
  buildingId: number | null,
  floorId: number | null
) =>
  createAction(GET_OCCUPANCY_AND_UTILIZATION_SUMMARIES, {
    roundIds,
    buildingId,
    floorId,
  });

const getOccupancyAndUtilizationSummariesSucceeded = (
  occupancyAndUtilizationSummaries: OccupancyAndUtilizationSummaries
) =>
  createAction(GET_OCCUPANCY_AND_UTILIZATION_SUMMARIES_SUCCEEDED, {
    occupancyAndUtilizationSummaries,
  });

const cleanUpOccupancyAndUtilizationSummaries = () =>
  createAction(CLEAN_UP_OCCUPANCY_AND_UTILIZATION_SUMMARIES);

const cleanUpOU = () => createAction(CLEAN_UP_OU);

const setCurrentRound = (round: IRound) =>
  createAction(SET_CURRENT_ROUND, { round });

const setCurrentRoundBuilding = (building: IBuilding) =>
  createAction(SET_CURRENT_ROUND_BUILDING, { building });

const setCurrentRoundFloor = (floor: IFloor) =>
  createAction(SET_CURRENT_ROUND_FLOOR, { floor });

const setCurrentSpaceCategory = (category: Category) =>
  createAction(SET_CURRENT_ROUND_SPACE_CATEGORY, { category });

const populateRoundUsages = (usages: IUsage[]) =>
  createAction(POPULATE_ROUND_USAGES, { usages });

const populateRoundPhotos = (photos: IPhoto[]) =>
  createAction(POPULATE_ROUND_PHOTOS, { photos });

const fetchPhotosForRound = (id: number) =>
  createAction(FETCH_ROUND_PHOTOS, { id });

const setRoundsRequestStatus = (status: REQUEST_STATUS) =>
  createAction(SET_ROUNDS_REQUEST_STATUS, { status });

const setReportZipFileName = (zipFileName: string) =>
  createAction(SET_REPORT_ZIP_FILE_NAME, { zipFileName });

export const actions = {
  fetchProjectsRounds,
  fetchProjectsRoundsSucceeded,
  fetchSpaceRounds,
  fetchSpaceRoundsSucceeded,
  getOccupancyAndUtilizationSummaries,
  getOccupancyAndUtilizationSummariesSucceeded,
  cleanUpOccupancyAndUtilizationSummaries,
  cleanUpOU,
  setCurrentRound,
  setCurrentRoundBuilding,
  setCurrentRoundFloor,
  setCurrentSpaceCategory,
  populateRoundUsages,
  populateRoundPhotos,
  fetchPhotosForRound,
  setRoundsRequestStatus,
  setReportZipFileName,
};
